import { atom, useAtom, useAtomValue } from "jotai";

export const optionLimitPriceAtom = atom<string>("");

export const optionLimitPriceNumAtom = atom((get) =>
  Number(get(optionLimitPriceAtom)),
);

export const useOptionLimitPrice = () => {
  const [optionLimitPrice, setOptionLimitPrice] = useAtom(optionLimitPriceAtom);
  const optionLimitPriceNum = useAtomValue(optionLimitPriceNumAtom);

  return {
    optionLimitPrice,
    optionLimitPriceNum,
    setOptionLimitPrice,
  };
};
